import { render } from "./blogs_rightside.vue?vue&type=template&id=427dce8e"
import script from "./blogs_rightside.vue?vue&type=script&lang=js"
export * from "./blogs_rightside.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__